import React, { useEffect } from "react";
import Navbar from "../common/Navbar";
import ContactUs from "../common/ContactUs";
import Footer from "../common/Footer";
import LogoComponent from "../common/LogoComponent";

const FounderPage = () => {
  useEffect(() => {
    document.title = "Founder";
  }, []);

  return (
    <div
      className="bg-white text-dark"
      style={{ fontFamily: "Arial, sans-serif" }}
    >
      <Navbar />

      {/* Hero Section */}
      <section className="" style={{ padding: "150px 0px", width: "100%" }}>
        <div className="container text-center">
          <h1 className="display-3" id="main-font">
            Meet the Founder
          </h1>
          <h1 className="display-5" id="main-font">
            Daniel M. Risis — Architect of the First Post-Legal Order
          </h1>
          <p className="lead mt-4 mb-0 px-md-5">
            Daniel M. Risis is not a lawyer. He is something far more
            threatening to the legal system: A man who no longer believes in it
            — and built a machine to replace it.
          </p>
          <p className="lead mt-4 mb-0 px-md-5">
            He is something far more threatening to the legal system:
          </p>
          <p className="lead mt-4 mb-0 px-md-5">
            A man who no longer believes in it — and built a machine to replace
            it.
          </p>
          <p className="lead mt-4 mb-0 px-md-5">
            After surviving{" "}
            <span style={{ fontWeight: "bold" }}>
              over $100 million in coordinated fraud
            </span>{" "}
            — including illegal foreclosures, falsified documents, collusive
            trustees, and rampant judicial misconduct — Daniel reached a
            breaking point. But rather than break down, he broke through.
          </p>
          <p className="lead mt-4 mb-0 px-md-5">
            From that fire, he forged{" "}
            <span style={{ fontWeight: "bold" }}>ProSlay</span> — the world’s
            first legal consultancy designed exclusively for pro se litigants.
            Powered by an AI system he built himself named{" "}
            <span style={{ fontWeight: "bold" }}>Kasper</span> , and backed by a
            team of human compliance reviewers, ProSlay isn’t a law firm — it’s
            a complete system reboot.
          </p>
          <p className="lead mt-4 mb-0 px-md-5">
            “They took my homes, my bank accounts, my company, and even tried to
            take my children. So I gave them something they never planned for —
            an army of pro se litigants with math on their side.”
          </p>
        </div>
      </section>

      {/* System Failure Section */}
      <section className="py-5 bg-light">
        <div className="container text-center">
          <h1 className="mb-3 display-4" id="main-font">
            System Failure Meets System Builder
          </h1>
          <p className="lead mb-3 px-md-5">
            Before ProSlay, Daniel served as
            <span style={{ fontWeight: "bold" }}>
              {" "}
              CEO of Pierce Bainbridge
            </span>
            , one of the most aggressive litigation outfits in the country.
            There, he worked on high-profile strategies — most famously the{" "}
            <span style={{ fontWeight: "bold" }}> Kyle Rittenhouse</span> case
            and the legal defense of{" "}
            <span style={{ fontWeight: "bold" }}> Tulsi Gabbard</span>, who now
            serves as{" "}
            <span style={{ fontWeight: "bold" }}>
              Director of National Intelligence
            </span>
            .
          </p>
          <p className="lead mb-3 px-md-5">
            But it was Daniel’s personal experiences that changed the course of
            legal history.
          </p>
          <p className="lead mb-3 px-md-5">
            He witnessed how{" "}
            <span style={{ fontWeight: "bold" }}>
              {" "}
              trustees steal with impunity
            </span>
            , how{" "}
            <span style={{ fontWeight: "bold" }}>
              lawyers evade all consequence
            </span>
            , and how{" "}
            <span style={{ fontWeight: "bold" }}>
              {" "}
              the courts protect the corrupt
            </span>{" "}
            — all while real victims go broke trying to be heard.
          </p>
          <p className="lead mb-3 px-md-5">
            So he did what the system could not:
          </p>
          <p className="lead mb-3 px-md-5">
            He built <span style={{ fontWeight: "bold" }}> Kasper</span>, an AI
            tool that predicts case outcomes, formats court-ready filings, and
            never forgets the rules of procedure.
          </p>
          <p className="lead mb-3 px-md-5">
            Then he backed it with a radical promise:
          </p>
          <p className="lead mb-3 px-md-5">
            <span style={{ fontWeight: "bold" }}>
              If we can’t deliver results, we give your money back
            </span>
            .
          </p>
          <p className="lead mb-3 px-md-5">No other firm dares say that.</p>
        </div>
      </section>

      {/* Pro Se Litigant Section */}
      <section className="py-5 bg-white">
        <div className="container text-center py-5">
          <h1 className="mb-3 display-4" id="main-font">
            The Most Successful Pro Se Litigant in Modern History
          </h1>
          <p className="lead mb-0 px-md-5 mb-5">
            <h3 className="display-5" id="main-font">
            Daniel is widely considered the most prolific and impactful pro se
            litigant in the country:
            </h3>
          </p>
          <ul className="lead mb-0 px-md-5 text-start">
            <li className="mb-2 ms-3">
              Filed <span style={{ fontWeight: "bold" }}>5,000+ motions</span>,
              petitions, objections, and appeals.
            </li>
            <li className="mb-2 ms-3">
              Defeated banks, trustees, and government officials without an
              attorney.
            </li>
            <li className="mb-2 ms-3">
              Developed the{" "}
              <span style={{ fontWeight: "bold" }}>Text2Court™ system</span>,
              converting digital communications into court-admissible PDFs under
              Rule 902.
            </li>
            <li className="mb-2 ms-3 mb-3">
              Personally launched dozens of lawsuits and defenses involving over
              <span style={{ fontWeight: "bold" }}>
                $100 million in disputed assets
              </span>
              .
            </li>
          </ul>
          <p className="lead mb-3 px-md-5 mt-3" id="main-font">
            He has outperformed elite counsel —{" "}
            <span style={{ fontWeight: "bold" }}>with zero law license</span>,
            just data and grit.
          </p>
        </div>
      </section>

      {/* Pro-Slay Disruptor Section */}
      <section className="py-5 bg-light">
        <div className="container text-center py-5">
          <h1 className="mb-3 display-4" id="main-font">
            ProSlay: The Legal Industry’s Multi-Billion Dollar Disruptor
          </h1>
          <p className="lead px-md-5">
            <span style={{ fontWeight: "bold" }}>ProSlay</span> is not a tech
            company.
          </p>
          <p className="lead px-md-5">It’s not a firm.</p>
          <p className="lead px-md-5">
            It’s a{" "}
            <span style={{ fontWeight: "bold" }}>post-legal institution</span>{" "}
            designed for the era of broken courts and awakened citizens.
          </p>

          <p className="lead mb-0 px-md-5 text-start mt-5 py-3">
            <h3 className="display-5" id="main-font">
            In a $400 billion legal industry built on:
            </h3>
          </p>
          <ul className="lead mb-0 px-md-5 text-start">
            <li className="mb-2 ms-3">
              Hourly billing with no accountability,
            </li>
            <li className="mb-2 ms-3">Lawyers who guarantee nothing,</li>
            <li className="mb-2 ms-3 mb-3">
              And clients who pay for failure...
            </li>
          </ul>

          <p className="lead mb-0 px-md-5 text-start">
            <h3 className="display-5" id="main-font">
              ProSlay flips the script:
            </h3>
          </p>
          <ul className="lead mb-0 px-md-5 text-start">
            <li className="mb-2 ms-3">
              <span style={{ fontWeight: "bold" }}>Flat-rate pricing</span>.
            </li>
            <li className="mb-2 ms-3">
              <span style={{ fontWeight: "bold" }}>
                Human + AI compliance on every motion
              </span>
              .
            </li>
            <li className="mb-2 ms-3">
              <span style={{ fontWeight: "bold" }}>
                Outcome prediction tools
              </span>
              .
            </li>
            <li className="mb-2 ms-3 mb-3">
              <span style={{ fontWeight: "bold" }}>
                {" "}
                Full money-back guarantee
              </span>
              .
            </li>
          </ul>
          <p className="lead mb-3 px-md-5 mt-4 pt-3" id="main-font">
            No more gatekeepers. No more scams. No more excuses.
          </p>
          <p className="lead mb-3 px-md-5 font-italic" id="main-font">
            “We don’t offer legal advice — we restore legal power to the
            people.”
          </p>
        </div>
      </section>

      {/* Core Philosophy Section */}
      <section className="py-5 bg-white">
        <div className="container text-center py-5">
          <h1 className="mb-3 display-4" id="main-font">
            Core Philosophy
          </h1>
          <p className="lead mb-3 px-md-5">
            ProSlay exists because the system doesn’t.
          </p>
          <p className="lead mb-3 px-md-5" id="main-font">The courts have become lawless. The lawyers have become reckless. The truth has become optional.</p>
          <p className="lead mb-3 px-md-5"></p>
          <p className="lead mb-3 px-md-5"></p>
          <h1 className="lead mb-3 px-md-5 display-4" id="main-font">Daniel’s vision is simple:</h1>
          <p className="lead mb-3 px-md-5 font-italic">
            “The Constitution wasn’t written in legalese. It was written in
            courage. We just translated it back.”
          </p>
          <p className="lead mb-3 px-md-5">
            ProSlay is{" "}
            <span style={{ fontWeight: "bold" }}>
              {" "}
              the first firm to staff exclusively women
            </span>
            , in response to the toxic masculinity and gender bias of the
            traditional legal community.
          </p>
          <p className="lead mb-3 px-md-5">
            For every overpaid male attorney billing $700/hour, Daniel hires
            <span style={{ fontWeight: "bold" }}>seven women at $100k </span>who
            each manage 20x more cases — with better outcomes.
          </p>
        </div>
      </section>

      {/* Highlights & Credentials Section */}
      <section className="py-5 bg-light">
        <div className="container text-center py-5">
          <h1 className="mb-3 display-4 mb-5" id="main-font">
            Highlights & Credentials
          </h1>
          <ul className="lead mb-0 px-md-5 text-start">
            <li className="mb-2 ms-3">
              <span style={{ fontWeight: "bold" }}>CEO, Pierce Bainbridge</span>{" "}
              – spearheaded high-profile constitutional litigation.
            </li>
            <li className="mb-2 ms-3">
              <span style={{ fontWeight: "bold" }}>Lead strategist</span>, Kyle
              Rittenhouse and Tulsi Gabbard matters.
            </li>
            <li className="mb-2 ms-3">
              Filed{" "}
              <span style={{ fontWeight: "bold" }}>
                {" "}
                5,000+ court documents
              </span>
              , often beating firms 100x his size.
            </li>
            <li className="mb-2 ms-3">
              Exposed the network behind{" "}
              <span style={{ fontWeight: "bold" }}>
                Senator Bob Menendez’s indictment
              </span>{" "}
              and the financial empire of  <span style={{ fontWeight: "bold" }}>Fred Daibes</span>.
            </li>
            <li className="mb-2 ms-3">
              Inventor of Kasper, the world’s first pro se litigation AI.
            </li>
            <li className="mb-2 ms-3">
              Developer of Text2Court™, standardizing digital evidence for
              courtroom use.
            </li>
            <li className="mb-2 ms-3">
              Founder of Cash Cow Cleanouts, MikroBank, Drake’s BBQ, and My
              Husband’s BBQ.
            </li>
            <li className="mb-2 ms-3">Scored perfect SATs three times.</li>
            <li className="mb-2 ms-3">Mastered 6 languages.</li>
            <li className="mb-2 ms-3">
              Earned a trading jacket on the NYMEX at age 15 — the youngest
              ever.
            </li>
            <li className="mb-2 ms-3">
              Survivor of corruption, collapse, betrayal, and injustice — who
              built a way out.
            </li>
          </ul>
        </div>
      </section>

      {/* Final Word Section */}
      <section className="py-5 bg-white">
        <div className="container text-center py-4">
          <h1 className="mb-4 display-4" id="main-font">
            Final Word
          </h1>
          <p className="lead mb-3 px-md-5 font-italic">
            “They had all the lawyers.
          </p>
          <p className="lead mb-3 px-md-5 font-italic">All the banks.</p>
          <p className="lead mb-3 px-md-5 font-italic">All the judges.</p>
          <p className="lead mb-3 px-md-5 font-italic">I had Kasper.</p>
          <p className="lead mb-3 px-md-5 font-italic">And now… so do you.”</p>
          <p className="lead mb-3 px-md-5">
            <h1 className="mb-3 display-4" id="main-font">
              ProSlay is not a company. It’s a rebellion in a suit.
            </h1>
          </p>
          <p className="lead mb-3 px-md-5">
            <h1 className="mb-3 display-4" id="main-font">
              A billion-dollar counterattack against the oldest scam in the
              system: billable justice.
            </h1>
          </p>
          <p className="lead mb-3 px-md-5">
            Welcome to the future. It’s pro se. And it’s finally fair.
          </p>
          <p className="lead mb-3 px-md-5">It’s pro se.</p>
          <p className="lead mb-3 px-md-5">And it’s finally fair.</p>
        </div>
      </section>

      <ContactUs />
      <Footer />
    </div>
  );
};

export default FounderPage;
